import { ListenerApiLight, _select, _take } from '../../listenerMiddleware';
import * as conflictResolverActions from './actions';
import { AutoConflictResolution, UserDecisionConflictResolution } from './model';
import { getConflictResolution } from './selectors';

async function awaitResoliton(lapi: ListenerApiLight) {
  const action = await _take(lapi, conflictResolverActions.resolutionCompleted);
  const decision =
    action.payload.newValue === UserDecisionConflictResolution.Overwrite ||
    action.payload.newValue === UserDecisionConflictResolution.OverwriteAll
      ? AutoConflictResolution.Overwrite
      : AutoConflictResolution.Skip;
  return decision;
}
export async function resolve(lapi: ListenerApiLight, filename: string) {
  let autoResolution = _select(lapi, getConflictResolution);
  // смотрим, есть ли "Overwrite/Skip All"

  if (autoResolution === AutoConflictResolution.Ask) {
    // если него нет, то показываем форму
    lapi.dispatch(conflictResolverActions.resolutionInitiated({ filename }));
    autoResolution = await awaitResoliton(lapi);
    //TODO: shouldn't matter what we return if signal is aborted. Don't like this line though
    if (lapi.signal.aborted) return AutoConflictResolution.Skip;
  }
  return autoResolution;
}
